/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seat_Price_Scheduled_TitleInputs */



/**
* | output |
* | --- |
* | "Nothing is charged today" |
*
* @param {Seat_Price_Scheduled_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_price_scheduled_title = /** @type {((inputs?: Seat_Price_Scheduled_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Price_Scheduled_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Heute wird nichts berechnet")
	return /** @type {LocalizedString} */ ("Nothing is charged today")
});